import {
    BasicQualificationInterface,
    QualificationInterface,
} from "../interfaces/QualificationInterface";

interface Props {
    qualification: QualificationInterface;
    establishmentAchievedQualifications: BasicQualificationInterface[];
    employeeAchievedQualifications: BasicQualificationInterface[];
    isEstablishmentManager: boolean;
}

export const isQualificationAchieved = (props: Props): boolean => {
    const {
        qualification,
        establishmentAchievedQualifications,
        employeeAchievedQualifications,
        isEstablishmentManager,
    } = props;

    if (!isEstablishmentManager) {
        return employeeAchievedQualifications.some(
            (achievedQualification) =>
                achievedQualification.id === qualification.id,
        );
    }

    return establishmentAchievedQualifications.some(
        (achievedQualification) =>
            achievedQualification.id === qualification.id,
    );
};
